import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getLogger, isFunction } from "../Utils/Utils";
import { Canvas } from "./Canvas";
import { EventListeners } from "./Utils/EventListeners";
import { Options } from "../Options/Classes/Options";
import { Particles } from "./Particles";
import { Retina } from "./Retina";
import { errorPrefix } from "./Utils/Constants";
import { getRangeValue } from "../Utils/NumberUtils";
import { loadOptions } from "../Utils/OptionsUtils";

function guardCheck(container) {
  return container && !container.destroyed;
}

function initDelta(value) {
  var fpsLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
  var smooth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value: value,
    factor: smooth ? 60 / fpsLimit : 60 * value / 1000
  };
}

function loadContainerOptions(engine, container) {
  var options = new Options(engine, container);

  for (var _len = arguments.length, sourceOptionsArr = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sourceOptionsArr[_key - 2] = arguments[_key];
  }

  loadOptions.apply(void 0, [options].concat(sourceOptionsArr));
  return options;
}

var defaultPathGeneratorKey = "default",
    defaultPathGenerator = {
  generate: function generate(p) {
    return p.velocity;
  },
  init: function init() {},
  update: function update() {},
  reset: function reset() {}
};
export var Container = /*#__PURE__*/function () {
  function Container(engine, id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;

    this._intersectionManager = function (entries) {
      if (!guardCheck(_this) || !_this.actualOptions.pauseOnOutsideViewport) {
        return;
      }

      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;

          if (entry.target !== _this.interactivity.element) {
            continue;
          }

          (entry.isIntersecting ? _this.play : _this.pause)();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    this._nextFrame = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timestamp) {
        var _this$lastFrameTime, delta;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(!_this.smooth && _this.lastFrameTime !== undefined && timestamp < _this.lastFrameTime + 1000 / _this.fpsLimit)) {
                  _context.next = 4;
                  break;
                }

                _this.draw(false);

                return _context.abrupt("return");

              case 4:
                (_this$lastFrameTime = _this.lastFrameTime) !== null && _this$lastFrameTime !== void 0 ? _this$lastFrameTime : _this.lastFrameTime = timestamp;
                delta = initDelta(timestamp - _this.lastFrameTime, _this.fpsLimit, _this.smooth);

                _this.addLifeTime(delta.value);

                _this.lastFrameTime = timestamp;

                if (!(delta.value > 1000)) {
                  _context.next = 11;
                  break;
                }

                _this.draw(false);

                return _context.abrupt("return");

              case 11:
                _context.next = 13;
                return _this.particles.draw(delta);

              case 13:
                if (_this.alive()) {
                  _context.next = 16;
                  break;
                }

                _this.destroy();

                return _context.abrupt("return");

              case 16:
                if (_this.getAnimationStatus()) {
                  _this.draw(false);
                }

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                getLogger().error("".concat(errorPrefix, " in animation loop"), _context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    this._engine = engine;
    this.fpsLimit = 120;
    this.smooth = false;
    this._delay = 0;
    this._duration = 0;
    this._lifeTime = 0;
    this._firstStart = true;
    this.started = false;
    this.destroyed = false;
    this._paused = true;
    this.lastFrameTime = 0;
    this.zLayers = 100;
    this.pageHidden = false;
    this._sourceOptions = sourceOptions;
    this._initialSourceOptions = sourceOptions;
    this.retina = new Retina(this);
    this.canvas = new Canvas(this);
    this.particles = new Particles(this._engine, this);
    this.pathGenerators = new Map();
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this._options = loadContainerOptions(this._engine, this);
    this.actualOptions = loadContainerOptions(this._engine, this);
    this._eventListeners = new EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        return _this._intersectionManager(entries);
      });
    }

    this._engine.dispatchEvent("containerBuilt", {
      container: this
    });
  }

  _createClass(Container, [{
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "sourceOptions",
    get: function get() {
      return this._sourceOptions;
    }
  }, {
    key: "addClickHandler",
    value: function addClickHandler(callback) {
      var _this2 = this;

      if (!guardCheck(this)) {
        return;
      }

      var el = this.interactivity.element;

      if (!el) {
        return;
      }

      var clickOrTouchHandler = function clickOrTouchHandler(e, pos, radius) {
        if (!guardCheck(_this2)) {
          return;
        }

        var pxRatio = _this2.retina.pixelRatio,
            posRetina = {
          x: pos.x * pxRatio,
          y: pos.y * pxRatio
        },
            particles = _this2.particles.quadTree.queryCircle(posRetina, radius * pxRatio);

        callback(e, particles);
      };

      var clickHandler = function clickHandler(e) {
        if (!guardCheck(_this2)) {
          return;
        }

        var mouseEvent = e,
            pos = {
          x: mouseEvent.offsetX || mouseEvent.clientX,
          y: mouseEvent.offsetY || mouseEvent.clientY
        };
        clickOrTouchHandler(e, pos, 1);
      };

      var touchStartHandler = function touchStartHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touched = true;
        touchMoved = false;
      };

      var touchMoveHandler = function touchMoveHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touchMoved = true;
      };

      var touchEndHandler = function touchEndHandler(e) {
        if (!guardCheck(_this2)) {
          return;
        }

        if (touched && !touchMoved) {
          var touchEvent = e;
          var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];

          if (!lastTouch) {
            lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - 1];

            if (!lastTouch) {
              return;
            }
          }

          var element = _this2.canvas.element,
              canvasRect = element ? element.getBoundingClientRect() : undefined,
              pos = {
            x: lastTouch.clientX - (canvasRect ? canvasRect.left : 0),
            y: lastTouch.clientY - (canvasRect ? canvasRect.top : 0)
          };
          clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
        }

        touched = false;
        touchMoved = false;
      };

      var touchCancelHandler = function touchCancelHandler() {
        if (!guardCheck(_this2)) {
          return;
        }

        touched = false;
        touchMoved = false;
      };

      var touched = false,
          touchMoved = false;
      el.addEventListener("click", clickHandler);
      el.addEventListener("touchstart", touchStartHandler);
      el.addEventListener("touchmove", touchMoveHandler);
      el.addEventListener("touchend", touchEndHandler);
      el.addEventListener("touchcancel", touchCancelHandler);
    }
  }, {
    key: "addLifeTime",
    value: function addLifeTime(value) {
      this._lifeTime += value;
    }
  }, {
    key: "addPath",
    value: function addPath(key, generator) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!guardCheck(this) || !override && this.pathGenerators.has(key)) {
        return false;
      }

      this.pathGenerators.set(key, generator !== null && generator !== void 0 ? generator : defaultPathGenerator);
      return true;
    }
  }, {
    key: "alive",
    value: function alive() {
      return !this._duration || this._lifeTime <= this._duration;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this3 = this;

      if (!guardCheck(this)) {
        return;
      }

      this.stop();
      this.particles.destroy();
      this.canvas.destroy();

      var _iterator2 = _createForOfIteratorHelper(this.drawers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              drawer = _step2$value[1];

          drawer.destroy && drawer.destroy(this);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.drawers.keys()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var key = _step3.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._engine.plugins.destroy(this);

      this.destroyed = true;

      var mainArr = this._engine.dom(),
          idx = mainArr.findIndex(function (t) {
        return t === _this3;
      });

      if (idx >= 0) {
        mainArr.splice(idx, 1);
      }

      this._engine.dispatchEvent("containerDestroyed", {
        container: this
      });
    }
  }, {
    key: "draw",
    value: function draw(force) {
      var _this4 = this;

      if (!guardCheck(this)) {
        return;
      }

      var refreshTime = force;
      this._drawAnimationFrame = requestAnimationFrame( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timestamp) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (refreshTime) {
                    _this4.lastFrameTime = undefined;
                    refreshTime = false;
                  }

                  _context2.next = 3;
                  return _this4._nextFrame(timestamp);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "export",
    value: function () {
      var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(type) {
        var options,
            _iterator4,
            _step4,
            _step4$value,
            plugin,
            res,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                _iterator4 = _createForOfIteratorHelper(this.plugins);
                _context3.prev = 2;

                _iterator4.s();

              case 4:
                if ((_step4 = _iterator4.n()).done) {
                  _context3.next = 16;
                  break;
                }

                _step4$value = _slicedToArray(_step4.value, 2), plugin = _step4$value[1];

                if (plugin.export) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("continue", 14);

              case 8:
                _context3.next = 10;
                return plugin.export(type, options);

              case 10:
                res = _context3.sent;

                if (res.supported) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("continue", 14);

              case 13:
                return _context3.abrupt("return", res.blob);

              case 14:
                _context3.next = 4;
                break;

              case 16:
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](2);

                _iterator4.e(_context3.t0);

              case 21:
                _context3.prev = 21;

                _iterator4.f();

                return _context3.finish(21);

              case 24:
                getLogger().error("".concat(errorPrefix, " - Export plugin with type ").concat(type, " not found"));

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 18, 21, 24]]);
      }));

      function _export(_x3) {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this._paused && !this.pageHidden && guardCheck(this);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      if (!guardCheck(this)) {
        return;
      }

      this.particles.handleClickMode(mode);

      var _iterator5 = _createForOfIteratorHelper(this.plugins),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              plugin = _step5$value[1];

          plugin.handleClickMode && plugin.handleClickMode(mode);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var shapes, _iterator6, _step6, type, drawer, availablePlugins, _iterator7, _step7, _step7$value, id, plugin, _iterator8, _step8, _step8$value, _drawer, _iterator9, _step9, _step9$value, _plugin, _iterator10, _step10, _step10$value, _plugin2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (guardCheck(this)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                shapes = this._engine.plugins.getSupportedShapes();
                _iterator6 = _createForOfIteratorHelper(shapes);

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    type = _step6.value;
                    drawer = this._engine.plugins.getShapeDrawer(type);

                    if (drawer) {
                      this.drawers.set(type, drawer);
                    }
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }

                this._options = loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
                this.actualOptions = loadContainerOptions(this._engine, this, this._options);
                availablePlugins = this._engine.plugins.getAvailablePlugins(this);
                _iterator7 = _createForOfIteratorHelper(availablePlugins);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _step7$value = _slicedToArray(_step7.value, 2), id = _step7$value[0], plugin = _step7$value[1];
                    this.plugins.set(id, plugin);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                this.retina.init();
                _context4.next = 13;
                return this.canvas.init();

              case 13:
                this.updateActualOptions();
                this.canvas.initBackground();
                this.canvas.resize();
                this.zLayers = this.actualOptions.zLayers;
                this._duration = getRangeValue(this.actualOptions.duration) * 1000;
                this._delay = getRangeValue(this.actualOptions.delay) * 1000;
                this._lifeTime = 0;
                this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 120;
                this.smooth = this.actualOptions.smooth;
                _iterator8 = _createForOfIteratorHelper(this.drawers);
                _context4.prev = 23;

                _iterator8.s();

              case 25:
                if ((_step8 = _iterator8.n()).done) {
                  _context4.next = 33;
                  break;
                }

                _step8$value = _slicedToArray(_step8.value, 2), _drawer = _step8$value[1];
                _context4.t0 = _drawer.init;

                if (!_context4.t0) {
                  _context4.next = 31;
                  break;
                }

                _context4.next = 31;
                return _drawer.init(this);

              case 31:
                _context4.next = 25;
                break;

              case 33:
                _context4.next = 38;
                break;

              case 35:
                _context4.prev = 35;
                _context4.t1 = _context4["catch"](23);

                _iterator8.e(_context4.t1);

              case 38:
                _context4.prev = 38;

                _iterator8.f();

                return _context4.finish(38);

              case 41:
                _iterator9 = _createForOfIteratorHelper(this.plugins);
                _context4.prev = 42;

                _iterator9.s();

              case 44:
                if ((_step9 = _iterator9.n()).done) {
                  _context4.next = 52;
                  break;
                }

                _step9$value = _slicedToArray(_step9.value, 2), _plugin = _step9$value[1];
                _context4.t2 = _plugin.init;

                if (!_context4.t2) {
                  _context4.next = 50;
                  break;
                }

                _context4.next = 50;
                return _plugin.init();

              case 50:
                _context4.next = 44;
                break;

              case 52:
                _context4.next = 57;
                break;

              case 54:
                _context4.prev = 54;
                _context4.t3 = _context4["catch"](42);

                _iterator9.e(_context4.t3);

              case 57:
                _context4.prev = 57;

                _iterator9.f();

                return _context4.finish(57);

              case 60:
                this._engine.dispatchEvent("containerInit", {
                  container: this
                });

                this.particles.init();
                this.particles.setDensity();
                _iterator10 = _createForOfIteratorHelper(this.plugins);

                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    _step10$value = _slicedToArray(_step10.value, 2), _plugin2 = _step10$value[1];
                    _plugin2.particlesSetup && _plugin2.particlesSetup();
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }

                this._engine.dispatchEvent("particlesSetup", {
                  container: this
                });

              case 66:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[23, 35, 38, 41], [42, 54, 57, 60]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "loadTheme",
    value: function () {
      var _loadTheme = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (guardCheck(this)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                this._currentTheme = name;
                _context5.next = 5;
                return this.refresh();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadTheme(_x4) {
        return _loadTheme.apply(this, arguments);
      }

      return loadTheme;
    }()
  }, {
    key: "pause",
    value: function pause() {
      if (!guardCheck(this)) {
        return;
      }

      if (this._drawAnimationFrame !== undefined) {
        cancelAnimationFrame(this._drawAnimationFrame);
        delete this._drawAnimationFrame;
      }

      if (this._paused) {
        return;
      }

      var _iterator11 = _createForOfIteratorHelper(this.plugins),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _step11$value = _slicedToArray(_step11.value, 2),
              plugin = _step11$value[1];

          plugin.pause && plugin.pause();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      if (!this.pageHidden) {
        this._paused = true;
      }

      this._engine.dispatchEvent("containerPaused", {
        container: this
      });
    }
  }, {
    key: "play",
    value: function play(force) {
      if (!guardCheck(this)) {
        return;
      }

      var needsUpdate = this._paused || force;

      if (this._firstStart && !this.actualOptions.autoPlay) {
        this._firstStart = false;
        return;
      }

      if (this._paused) {
        this._paused = false;
      }

      if (needsUpdate) {
        var _iterator12 = _createForOfIteratorHelper(this.plugins),
            _step12;

        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _step12$value = _slicedToArray(_step12.value, 2),
                plugin = _step12$value[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }

      this._engine.dispatchEvent("containerPlay", {
        container: this
      });

      this.draw(needsUpdate || false);
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (guardCheck(this)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                this.stop();
                return _context6.abrupt("return", this.start());

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (guardCheck(this)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                this._initialSourceOptions = undefined;
                this._options = loadContainerOptions(this._engine, this);
                this.actualOptions = loadContainerOptions(this._engine, this, this._options);
                return _context7.abrupt("return", this.refresh());

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      if (!guardCheck(this)) {
        return;
      }

      this.setPath(noiseOrGenerator, init, update);
    }
  }, {
    key: "setPath",
    value: function setPath(pathOrGenerator, init, update) {
      if (!pathOrGenerator || !guardCheck(this)) {
        return;
      }

      var pathGenerator = _objectSpread({}, defaultPathGenerator);

      if (isFunction(pathOrGenerator)) {
        pathGenerator.generate = pathOrGenerator;

        if (init) {
          pathGenerator.init = init;
        }

        if (update) {
          pathGenerator.update = update;
        }
      } else {
        var oldGenerator = pathGenerator;
        pathGenerator.generate = pathOrGenerator.generate || oldGenerator.generate;
        pathGenerator.init = pathOrGenerator.init || oldGenerator.init;
        pathGenerator.update = pathOrGenerator.update || oldGenerator.update;
      }

      this.addPath(defaultPathGeneratorKey, pathGenerator, true);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!guardCheck(this) || this.started)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _context9.next = 4;
                return this.init();

              case 4:
                this.started = true;
                _context9.next = 7;
                return new Promise(function (resolve) {
                  _this5._delayTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                    var _iterator13, _step13, _step13$value, plugin;

                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _this5._eventListeners.addListeners();

                            if (_this5.interactivity.element instanceof HTMLElement && _this5._intersectionObserver) {
                              _this5._intersectionObserver.observe(_this5.interactivity.element);
                            }

                            _iterator13 = _createForOfIteratorHelper(_this5.plugins);
                            _context8.prev = 3;

                            _iterator13.s();

                          case 5:
                            if ((_step13 = _iterator13.n()).done) {
                              _context8.next = 13;
                              break;
                            }

                            _step13$value = _slicedToArray(_step13.value, 2), plugin = _step13$value[1];
                            _context8.t0 = plugin.start;

                            if (!_context8.t0) {
                              _context8.next = 11;
                              break;
                            }

                            _context8.next = 11;
                            return plugin.start();

                          case 11:
                            _context8.next = 5;
                            break;

                          case 13:
                            _context8.next = 18;
                            break;

                          case 15:
                            _context8.prev = 15;
                            _context8.t1 = _context8["catch"](3);

                            _iterator13.e(_context8.t1);

                          case 18:
                            _context8.prev = 18;

                            _iterator13.f();

                            return _context8.finish(18);

                          case 21:
                            _this5._engine.dispatchEvent("containerStarted", {
                              container: _this5
                            });

                            _this5.play();

                            resolve();

                          case 24:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8, null, [[3, 15, 18, 21]]);
                  })), _this5._delay);
                });

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (!guardCheck(this) || !this.started) {
        return;
      }

      if (this._delayTimeout) {
        clearTimeout(this._delayTimeout);
        delete this._delayTimeout;
      }

      this._firstStart = true;
      this.started = false;

      this._eventListeners.removeListeners();

      this.pause();
      this.particles.clear();
      this.canvas.stop();

      if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) {
        this._intersectionObserver.unobserve(this.interactivity.element);
      }

      var _iterator14 = _createForOfIteratorHelper(this.plugins),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _step14$value = _slicedToArray(_step14.value, 2),
              plugin = _step14$value[1];

          plugin.stop && plugin.stop();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      var _iterator15 = _createForOfIteratorHelper(this.plugins.keys()),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var key = _step15.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      this._sourceOptions = this._options;

      this._engine.dispatchEvent("containerStopped", {
        container: this
      });
    }
  }, {
    key: "updateActualOptions",
    value: function updateActualOptions() {
      this.actualOptions.responsive = [];
      var newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
      this.actualOptions.setTheme(this._currentTheme);

      if (this.responsiveMaxWidth === newMaxWidth) {
        return false;
      }

      this.responsiveMaxWidth = newMaxWidth;
      return true;
    }
  }]);

  return Container;
}();